<template>
  <div class="">
    <div class="py-3 text-white fixed-top w-100 mx-auto" style="max-width: 480px;">
      <div class="container">
        <div class="d-flex justify-content-between align-items-center">
          <img src="/img/logopriadi.png" width="180" alt="Logo" />

          <div class="language-selector">
            <select class="form-select w-auto" v-model="currentLang" @change="switchLanguage">
              <option value="en">🇬🇧 English</option>
              <option value="id">🇮🇩 Indonesia</option>
              <option value="zh">🇨🇳 中文</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="slider-container">
      <transition name="fade" mode="out-in">
        <div :key="currentIndex" class="section d-flex align-items-center justify-content-center">
          <img :src="currentImage" :alt="'Section ' + (currentIndex + 1)" class="img-fluid" />
        </div>
      </transition>
    </div>

    <div class="bottom-drawer">
      <!-- Toggler: Positioned outside the drawer -->
      <div
        class="toggle-tab bg-white text-center"
        :class="isDrawerToggled ? 'tab-open' : 'tab-closed'"
        @click="toggleDrawer">
        <i
          class="bi"
          :class="['text-secondary', 'bi-chevron-compact-' + (isDrawerToggled ? 'up' : 'down')]"
          style="font-size: 2em"></i>
      </div>
      <!-- Drawer -->
      <div class="drawer-container bg-white rounded-top shadow shadow-lg" :class="{ 'drawer-open': isDrawerToggled }">
        <div class="drawer-content pt-1 pb-3">
          <div class="d-grid col-10 mx-auto">
            <p class="lead text-center">{{ $t('continueAs') }}</p>
            <div class="d-flex justify-content-center mx-auto mb-3">
              <button
                class="border border-info border-2 btn col-7 btn-light mx-2 mb-2"
                style="border-radius: 23px"
                @click="selectRole('individual')">
                <i class="bi bi-person-fill fs-1"></i><br />{{ $t('individual') }}
              </button>
              <button
                class="border border-info border-2 btn col-7 btn-light mx-2 mb-2"
                style="border-radius: 23px"
                @click="selectRole('hr')">
                <i class="bi bi-briefcase-fill fs-1"></i><br />{{ $t('corporate') }}
              </button>
            </div>
            <p class="text-center" style="font-size: 9pt">
              {{ $t('agreeTermsIntro') }}
              <a
                href="https://priadi.id/terms-condition-apps.html"
                target="_blank"
                rel="noreferrer noopener"
                class="text-decoration-underline fw-bold">
                {{ $t('termsCondition') }}
              </a>
              {{ $t('and') }}
              <a
                href="https://priadi.id/privacy-policy-apps.html"
                target="_blank"
                rel="noreferrer noopener"
                class="text-decoration-underline fw-bold">
                {{ $t('privacyPolicy') }}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loadLocaleMessages } from '../i18n'

export default {
  name: 'Intro',
  data() {
    return {
      isDrawerToggled: true,
      selectedLang: 'en',
      images: ['/img/intro-01.png', '/img/intro-02.png', '/img/intro-03.png', '/img/intro-04.png'],
      currentIndex: 0,
      intervalId: null,
    }
  },
  computed: {
    currentImage() {
      return this.images[this.currentIndex]
    },
    currentLang: {
      get() {
        return this.$store.getters.currentLocale
      },
      set(lang) {
        this.$store.dispatch('setLocale', lang)
      },
    },
  },
  async mounted() {
    // Detect browser language on first load if not already set
    if (!this.$store.getters.currentLocale) {
      const browserLang = navigator.language.split('-')[0]
      const fallback = ['en', 'id', 'zh'].includes(browserLang) ? browserLang : 'en'
      this.currentLang = fallback
      await this.switchLanguage()
    } else {
      this.selectedLang = this.currentLang
      await this.switchLanguage()
    }

    this.intervalId = setInterval(this.nextSection, 3000)
  },
  methods: {
    nextSection() {
      this.currentIndex = (this.currentIndex + 1) % this.images.length
    },
    toggleDrawer() {
      this.isDrawerToggled = !this.isDrawerToggled
    },
    selectRole(role) {
      this.$store.dispatch('setRole', role)
      if (this.$store.getters.getRole === 'hr') this.$router.push('/auth')
      else this.$router.push('/package')
    },
    async switchLanguage() {
      await loadLocaleMessages(this.currentLang)
    },
  },
  beforeUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  },
}
</script>

<style scoped>
.bottom-drawer {
  position: fixed;
  bottom: 0;
  width: 100%;
  max-width: 480px;
  z-index: 1050;
}

/* Toggle tab styles */
.toggle-tab {
  width: 100px;
  height: 40px;
  border-radius: 20px 20px 0 0;
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.35s ease-in-out;
  pointer-events: auto;
}

/* Fixed at bottom when closed */
.tab-closed {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1060;
}

/* Positioned above drawer when open */
.tab-open {
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1060;
}

/* Add pointer-events only to the drawer container when closed */
.drawer-container {
  transform: translateY(100%);
  transition: transform 0.35s ease-in-out;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding-top: 40px;
  position: relative;
  pointer-events: auto;
}

/* Slide drawer up */
.drawer-open {
  transform: translateY(0);
}

/* 1. Declare transition effects */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease-in-out; /* Adjust duration and easing as needed */
}

/* 2. State when the element is entering */
.fade-enter-from {
  opacity: 0;
}

/* 3. State when the element is leaving */
.fade-leave-to {
  opacity: 0;
}
</style>
